module.exports = __webpack_public_path__ + "assets/img/5_1312.7d3b0302.jpg";